<template>
  <el-table
    ref="zTable"
    :data="quotationList"
  >
    <af-table-column
      prop="varietyName"
      label="商品类目"
    />
    <af-table-column
      prop="tradeMarkName"
      label="品牌"
    />
    <af-table-column
      prop="pickupPosition"
      label="交货地点"
    />
    <af-table-column
      prop="priceType"
      label="报价类型"
    >
      <template v-slot="scope">
        {{ scope.row.priceType | keyFilter('myStore','priceType') }}
      </template>
    </af-table-column>
    <af-table-column
      prop="priceList"
      label="报价"
    >
      <template v-slot="scope">
        <div v-if="scope.row.priceType==='JTJ'">
          <el-popover
            placement="right"
            width="300"
            trigger="hover"
          >
            <el-table :data="scope.row.priceList">
              <el-table-column
                prop="unitPrice"
                label="单价"
               >
                <template slot-scope="scope">
                  {{scope.row.unitPrice | thousandMark}}
                </template>
              </el-table-column>
              <el-table-column
                prop="min"
                label="购买量(起购量)"
              />
            </el-table>
            <el-tag slot="reference">
              {{ scope.row.priceList.length }}
            </el-tag>
          </el-popover>
        </div>
        <div v-if="scope.row.priceType==='YKJ'">
          {{ scope.row.priceList[0].unitPrice | thousandMark }}
        </div>
      </template>
    </af-table-column>
    <af-table-column
      v-if="optType==='trade'"
      prop="totalQuantity"
      label="挂牌库存"
    >
      <template v-slot="scope">
        <el-input-number
          v-model.trim="scope.row.totalQuantity"
          class="w100"
          :controls="false"
          :min="0"
        />
        {{ scope.row.unitName }}
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'CheckedQuotation',
  components: {
  },
  props: {
    quotationList: {
      type: Array,
      default: () => []
    },
    optType: {
      type: String,
      default: ''
    }
  },

  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>

</style>
